// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2Q8w4","header":"PatientBlock_header__3Cm9D","label":"PatientBlock_label__27DrI","option":"PatientBlock_option__37wMG"};